export const ACCESS_ROLES = {
  STUDENT: 'STUDENT-ACESS-ROLE',
  TEACHER: 'TEACHER-ACESS-ROLE',
};
